import { render, staticRenderFns } from "./inquiryDetails.vue?vue&type=template&id=e70179c8&"
import script from "./inquiryDetails.vue?vue&type=script&lang=js&"
export * from "./inquiryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports